import { render, staticRenderFns } from "./NormalSearchNav502.vue?vue&type=template&id=70f08a03&scoped=true&"
import script from "./NormalSearchNav502.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav502.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f08a03",
  null
  
)

export default component.exports